import { Injectable, inject } from '@angular/core';
import {LorenBaseCrudService} from '../../../../shared/services/loren-base-crud-service/loren-base-crud.service';
import {LorenGeofencingCircle} from '../../interfaces/loren-geofencing-circle.interface';
import {LorenGeofencingEndpointsService} from '../loren-geofencing-endpoints-service/loren-geofencing-endpoints.service';

@Injectable({
    providedIn: 'root'
})
export class LorenGeofencingCircleService extends LorenBaseCrudService<LorenGeofencingCircle> {
    protected endpointsService: LorenGeofencingEndpointsService;


    constructor() {
        const endpointsService = inject(LorenGeofencingEndpointsService);

        super(endpointsService.geoFenceZonesCircles());

        this.endpointsService = endpointsService;
    }
}
